import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./services/authConfig.jsx";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { axiosInterceptor } from "./Interceptors/axiosInterceptor.jsx";
import * as am5 from "@amcharts/amcharts5";
import { environment } from "./environments/environment";
import { RenovationTokenContextProvider } from "./contexts/RenovationTokenContextProvider.jsx";
import { DropdownProvider } from "./contexts/DropdownGlobalDataContext.jsx";
import { SnackBarProvider } from "./contexts/SnackBarContext.jsx";
import { AlertProvider } from "./contexts/AlertContext.jsx";

const msalInstance = new PublicClientApplication(msalConfig);
am5.addLicense(environment.amchartLicense);
axiosInterceptor(); // makes sure to intercept every http request in the app and apply the logic necessary


createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <DropdownProvider>
    {/* <RenovationTokenContextProvider> */}
      <MsalProvider instance={msalInstance}>
        <SnackBarProvider>
          <AlertProvider>
            <App />
          </AlertProvider>
        </SnackBarProvider>
      </MsalProvider>
    {/* </RenovationTokenContextProvider> */}
  </DropdownProvider>
  // </StrictMode>,
);
